import React from 'react'

// utils.js
export const getImagePath = (imageName) => `/images/portfolio/${imageName}`;



